import React from 'react'
import { StaticQuery, Link } from 'gatsby'
import _ from 'lodash'
import Img from 'gatsby-image'
import styled from 'styled-components'

const BlogContent = styled.div`
  margin:3em 0;
  position: sticky;
    top: 100px;

  a {
   text-transform:uppercase;
   display:block;
  }

`

const ClientPostNav = () => (
  <StaticQuery
    query={graphql`
      query ClientPostNavigationQuery {
        allPrismicClient(sort: {fields: data___title___text, order: ASC}) {
          edges {
            node {
              data {
                title {
                text
              }
              }
              
            }
          }
        }
      }
    `}
    render={data => (
      <BlogContent>
        {data.allPrismicClient.edges.map(({ node }) => (
          <div>
            <Link to={`/${_.kebabCase(node.data.title.text)}`}>{node.data.title.text}  </Link>
          </div>
        ))}
      </BlogContent>
    )}
  />
)

export default ClientPostNav